import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { setAnalyticsChoice, trackPage, useAnalyticsChoice } from '../analytics';
import { analyticsConfigured } from '../config';

/** Sends a page view (route pattern only) on every navigation, if allowed. */
export function PageTracker() {
  const { pathname } = useLocation();
  useEffect(() => trackPage(pathname), [pathname]);
  return null;
}

/** Asks once per browser whether usage statistics may be collected. */
export function AnalyticsConsentBanner() {
  const choice = useAnalyticsChoice();
  if (!analyticsConfigured || choice !== null) return null;
  return (
    <div className="consent-banner" role="region" aria-label="Usage statistics">
      <p>
        May we collect anonymous usage statistics with Google Analytics? It records which pages and features are used,
        never client details. You can change this on the Account page.
      </p>
      <div className="actions">
        <button type="button" className="btn btn--primary" onClick={() => setAnalyticsChoice('granted')}>
          Allow
        </button>
        <button type="button" className="btn" onClick={() => setAnalyticsChoice('denied')}>
          No thanks
        </button>
      </div>
    </div>
  );
}

/** Account page card: shows and changes the choice. */
export function AnalyticsSetting() {
  const choice = useAnalyticsChoice();
  if (!analyticsConfigured) return null;
  const allowed = choice === 'granted';
  return (
    <div className="card">
      <h2>Usage statistics</h2>
      <p>
        {allowed
          ? 'Anonymous usage statistics are collected on this browser with Google Analytics: which pages and features are used, never client details.'
          : 'No usage statistics are collected on this browser.'}
      </p>
      <button type="button" className="btn" onClick={() => setAnalyticsChoice(allowed ? 'denied' : 'granted')}>
        {allowed ? 'Stop collecting' : 'Allow usage statistics'}
      </button>
    </div>
  );
}
